import {ForYouItemContent} from './ForYouItemContent'
import {LegacyForYouItem} from './ForYouItemLegacy'
import {isCanonicalForYouItemProps, type ForYouItemProps as ForYouItemPropsContract} from './for-you-item.types'

export type ForYouItemProps = ForYouItemPropsContract

export function ForYouItem(props: ForYouItemProps) {
  if (isCanonicalForYouItemProps(props)) {
    if (props.visual === undefined) {
      throw new Error('Canonical ForYouItem requires a visual')
    }
    if ('children' in props && props.children != null) {
      throw new Error('Canonical ForYouItem does not support children')
    }
    return <ForYouItemContent {...props} />
  }

  return <LegacyForYouItem {...props} />
}
